import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Skeleton } from "@circleco/compass/components/Skeleton";
import { useState } from "react";

import type { UploadedImage } from "../../store";

interface ThumbnailImageProps {
  currentImageIndex: number;
  image: UploadedImage;
  index: number;
  onClick: (index: number) => void;
}

export const ThumbnailImage = ({
  image,
  index,
  currentImageIndex,
  onClick,
}: ThumbnailImageProps) => {
  const [isLoading, setIsLoading] = useState(true);
  return (
    <button
      type="button"
      onPointerDown={() => onClick(index)}
      onClick={() => onClick(index)}
      className={classNames(
        "relative cursor-pointer touch-none select-none rounded-md border-2 border-transparent p-0.5",
        {
          "size-12": isLoading,
          "border-secondary": index === currentImageIndex && !isLoading,
        },
      )}
    >
      {isLoading && (
        <Skeleton
          shape="square"
          className="absolute inset-0 size-full rounded-md"
        />
      )}
      <img
        loading="eager"
        src={image.url}
        className={classNames("size-12 rounded-md object-cover", {
          hidden: isLoading,
        })}
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
        alt={image.filename}
      />
    </button>
  );
};
